import { render, staticRenderFns } from "./CVTabs.vue?vue&type=template&id=7069f82e&"
import script from "./CVTabs.vue?vue&type=script&lang=js&"
export * from "./CVTabs.vue?vue&type=script&lang=js&"
import style0 from "./CVTabs.vue?vue&type=style&index=0&id=7069f82e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports